module.exports = __webpack_public_path__ + "img/setting_22.86301463.svg";